import dayjs from 'dayjs'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../StockAdjustmentInBatchState'
import { AdjustmentsFilters } from '../../StockAdjustmentInBatchTypes'
import { objectFilterByValue } from './objectFilterByValue'
import * as S from './PendingAdjustmentFilter.styles'

export default () => {
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm<AdjustmentsFilters>()

  const { filters } = useSelector((state) => state.stockAdjustmentInBatch)

  const dispatch = useDispatch()

  const onSubmit: SubmitHandler<AdjustmentsFilters> = (selectedFilters) => {
    const validFilters = objectFilterByValue<AdjustmentsFilters>(selectedFilters, '0')
    dispatch(actions.setFilters(validFilters))
    dispatch(actions.resetMovements())
    dispatch(actions.getPendingAdjustments())
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <S.FilterContainer>
        <S.CustomTextField
          name='startDate'
          label='startDate.adjustment'
          type='date'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ...register('startDate', {
              required: 'Data de início é obrigatória',
            }),
            'data-testid': 'startDate-test',
            max: dayjs().format('YYYY-MM-DD'),
          }}
          error={!!errors.startDate}
          helperText={errors.startDate?.message}
          defaultValue={dayjs(filters.startDate).format('YYYY-MM-DD')}
        />
        <S.CustomTextField
          name='endDate'
          label='endDate.adjustment'
          type='date'
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ...register('endDate', {
              required: 'Data de fim é obrigatória',
              validate: (value) => {
                const startDate = watch('startDate')
                if (!startDate) {
                  return 'Data de início é obrigatória'
                }
                if (dayjs(value).isBefore(dayjs(startDate))) {
                  return 'Data de fim não pode ser menor do que a data de início'
                }
                const differenceInDays = dayjs(value).diff(dayjs(startDate), 'day')
                return differenceInDays <= 7 || 'A diferença entre as datas deve ser de no máximo 07 dias'
              },
            }),
            'data-testid': 'endDate-test',
            max: watch('startDate') ? dayjs(watch('startDate')).add(7, 'day').format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
          }}
          error={!!errors.endDate}
          helperText={errors.endDate?.message}
          defaultValue={dayjs(filters.endDate).format('YYYY-MM-DD')}
        />
        <S.CustomTextField
          name='user'
          label='Filtrar por usuário'
          type='text'
          id='user'
          placeholder='Busque pelo usuário'
          inputProps={{
            ...register('user'),
            'data-testid': 'user-test',
          }}
          defaultValue={filters.user}
        />
        <S.CustomButton
          title='Buscar'
          type='submit'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
        />
      </S.FilterContainer>
    </form>
  )
}
